
    import './styles.scoped.css';
    export default {
  "series": "awsui_series_y1yrh_1cxec_189",
  "root": "awsui_root_y1yrh_1cxec_203",
  "series--highlighted": "awsui_series--highlighted_y1yrh_1cxec_215",
  "series--dimmed": "awsui_series--dimmed_y1yrh_1cxec_219",
  "series--threshold": "awsui_series--threshold_y1yrh_1cxec_223",
  "popover-divider": "awsui_popover-divider_y1yrh_1cxec_228"
};
  